export default __webpack_public_path__ + "static/media/img_sneakpeek01.e042dfd2.png";